<template>
  <div :class="$style.content" id="about">
    <div :class="$style.title"><span>ФЭИС 20 лет</span></div>
    <div :class="$style.subtitle">Объединяя таланты, создаем будущее!</div>
    <div :class="$style.text">
      Факультет электронно-информационных систем отмечает 20 лет — и мы
      приглашаем вас на грандиозную юбилейную неделю! Погрузитесь в атмосферу
      инноваций и праздника вместе с нами. Вас ждут уникальные мастер-классы от
      ведущих IT-компаний и лидеров промышленности, интеллектуальные баттлы и
      хакатон с реальными задачами. Это ваш шанс вдохновиться историями успеха,
      пообщаться с будущими работодателями, завести полезные знакомства и
      выиграть призы. Не упустите возможность стать частью нашего большого
      праздника!
    </div>
  </div>
</template>

<style lang="scss" module>
.content {
  scroll-margin-block: 2rem;
  margin: 0 0 4rem 0;
  padding: 0 1rem;
  @include custom(530) {
    margin: 0 0 1rem 0;
  }
  .title {
    font-weight: 800;
    font-size: 2.875rem;
    text-align: center;
    margin: 0 0 0.75rem 0;
    span {
      color: $main;
      background-color: $white;
      padding: 0.625rem 1.25rem;
      border-radius: 5rem;
    }
    @include custom(420) {
      font-size: 2.3rem;
    }
  }
  .subtitle {
    font-family: "Pacifico";
    text-align: center;
    font-weight: 400;
    font-size: 2.625rem;
    margin: 0 0 2rem 0;
    @include custom(768) {
      font-size: 2rem;
    }
    @include custom(600) {
      font-size: 1.8rem;
    }
    @include custom(530) {
      font-size: 1.5rem;
      margin: 0 0 1rem 0;
    }
    @include custom(475) {
      font-size: 1.3rem;
    }
    @include custom(420) {
      font-size: 1rem;
    }
  }
  .text {
    font-weight: 500;
    font-size: 1.14rem;
    color: $grey-40;
    line-height: 150%;
    max-width: 66.5rem;
    text-align: center;
    margin: 0 auto;
    @include custom(768) {
      font-size: 1rem;
    }
    @include custom(530) {
      font-size: 0.8rem;
    }
  }
}
</style>
